/*
*****************************************************************************
*File :router.js
*Module : Dashboard Frontend
*Purpose :Defining the store variables for the cyberS Application
*Author : UI Team
*Copyright : Copyright 2021, Lab to Market Innovations Private Limited
*****************************************************************************
*/


import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState({
    storage: window.localStorage,
  })],
  state: {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: require(`@/assets/images/jsw-sidebar.jpeg`),
    drawer: null,
    playDateInfo: '',
    start_endYard: '',
    pieCntArr: [],
    pointIds: [],
    logUser: [],
    logUserAdmin: [],
    logUserCCA: [],
    logUserType: [],
    operationNotPermitted:'',
    dialog:true,
    userSelectedSection: 'S0',
    resetFlagCS: 0,
    switchFlag: 0,
    resetInitial: 0,
    routingAlert : false,
    pointNotLockedAlert :false,
    orangeTimerEnabled: false,
    sectionStatusColor: "grey",
    pointZoneSection: 0,
    sectionIdBlink: false,
    clearBlink: false,
    blinkCount: 0,
    barChartDates : [],
    barChartDates2 : [],
    barChartDates3 : [],
    // barChartDates4 : [],
    barChartDates5 : [],
    barChartDates6 : [],
    barChartDates7: [],
    barChartDates8 : [],
    barChartDates9 : [],
    pieChartHABDDatas : [],
    user_ip: '',
    token: '',
    snackbar:false,
    username: '',
    trainCount: [],
    defectCount: [],
    trainCount2: [],
    defectCount2: [],
    trainCount3: [],
    defectCount3: [],
    // trainCount4: [],
    // defectCount4: [],
    trainCount5: [],
    defectCount5: [],
    trainCount6: [],
    defectCount6: [],
    trainCount7: [],
    defectCount7: [],
    trainCount8: [],
    defectCount8: [],
    trainCount9: [],
    defectCount9: [],
    seriesPie :[],    
    seriestruePer: [],
    seriesTotalTrue: [],
    seriesTotalFalse: [],
    ackStatus: 0,
  },
  
  mutations: {
    SET_BAR_IMAGE(state, payload) {
      state.barImage = payload
    },
    SET_DRAWER(state, payload) {
      state.drawer = payload
    
    },
    SET_SCRIM(state, payload) {
      state.barColor = payload
    },
    SET_PIE_CNT(state, payload) {
      state.pieCntArr = payload
    },
    SET_USR_SEL_SECTION(state, payload) {
      state.userSelectedSection = payload
    },
  },
  actions: {

  }
})
